import { Type } from '$lib/form';
import type { TypedValidate } from '$types/form';

export const types = {
  edit: {
    key: Type.text,
    lang: Type.text,
    text: Type.text
  },
  image: {
    key: Type.text,
    file: Type.file
  }
} as const;

export const validate: TypedValidate<typeof types> = {
  edit: (values) => {
    if (values.key.length === 0) {
      return { message: 'Klíč musí být vyplněn', values: {} };
    }
    if (values.text.length === 0) {
      return { message: 'Text musí být vyplněn', values: {} };
    }
    return null;
  },
  image: (values) => {
    if (values.key.length === 0) {
      return { message: 'Klíč musí být vyplněn', values: {} };
    }
    if (values.file.size === 0) {
      return { message: 'Soubor musí být vyplněn', values: {} };
    }
    return null;
  }
};
